exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".gwnl-personality-select--no-header .yxt-tabs__header{display:none}\n", ""]);

